import Section from "@/lib/Section";
import store from "@/store";
import {ArrayQuestion} from "@/lib/ArrayQuestion";
import {Question} from "@/lib/Question";
import {ArraySectionItem} from "./ArraySectionItem";

export class ArraySection {
    public arrayQuestions: ArrayQuestion[] = [];
    //public arraySections: Section[] = [];
    public arraySectionItems: ArraySectionItem[] = [];
    constructor(section: Section) {
        //const arraySections = store.state.sections.filter((existingSection: Section) => (section.arraySectionIds.includes(existingSection.id) || (existingSection.id === 0 && section.arraySectionIds.includes(existingSection.parentSection!.id) ) ) );
        this.arraySectionItems = section.arraySectionItems;
        const additionalArraySectionItems = [];
        this.arraySectionItems.forEach((arraySectionItem: ArraySectionItem) => {
            const children = arraySectionItem.additional.children;
            children.forEach((child: Section) => {
                this.arraySectionItems.push(new ArraySectionItem(section, child, arraySectionItem.label, arraySectionItem.compositeLabelQuestions, arraySectionItem.conditions));
            });
        });

        section.questions.forEach((question: Question) => {
            this.arrayQuestions.push(new ArrayQuestion(question, this.arraySectionItems))
        });
    }
}
